/* GENERATED from design-system/assets/icons/close.svg — do not edit.
 * Regenerate: node design-system/scripts/build-assets.mjs */
import * as React from "react";
import type { IconProps } from "./props";
const Close = ({ size, ...props }: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? "1em"}
    height={size ?? "1em"}
    {...props}
  >
    <path
      d="M19 19L5 5"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 5L5 19"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Close;
